<template>
  <div>
    <alert-message-modal></alert-message-modal>
    <Navigation active="vegetativePlants"></Navigation>
    <div class="row">
      <div class="col-12 table-overlay">
        <div class="block">
          <div v-if="showLoader" class="overlay"></div>
          <hash-loader v-if="showLoader" class="hash-icon table-hash-icon" color="#70b9eb" loading="loading" size="40" sizeUnit="px"></hash-loader>
          <div class="block-header bg-info">
            <h3 class="block-title text-white"><i class="far fa-lightbulb fa-rotate-180"></i> Complete List of Plants In Vegetative Stage</h3>
          </div>
          <div class="block-content block-content-full table-overview">
              <table id="vegetative-overview-table" class="table table-bordered table-striped table-vcenter js-dataTable-full js-table-checkable ">
              <thead>
                <tr>
                  <th class="text-center" style="width: 80px;">ID</th>
                  <th class="text-center">Batch ID</th>
                  <th class="text-center">Strain</th>
                  <th class="text-center">Stage</th>
                  <th class="text-center">Planted Date</th>
                  <th class="text-center">Location</th>
                  <th class="text-center no-sorting">Advance</th>
                </tr>
              </thead>
              <tbody>{{ getVegetativePlantEntries }}
                <tr v-for="(plant, index) in vegetativePlants" :key="index">
                  <td class="text-center font-size-sm">
                    <router-link :to="`/vegetative/details/${plant.Id}`">{{ plant.Id }}</router-link>
                  </td>
                  <td class="text-center font-size-sm">{{ plant.PlantBatchId }}</td>
                  <td class="text-center text-break">
                    {{ plant.StrainName }}
                  </td>
                  <td class="text-center">
                    <span class="badge badge-info">{{ plant.GrowthPhase }}</span>
                  </td>
                  <td class="text-center font-size-sm">
                    <em class="text-muted">{{ plant.PlantedDate }}</em>
                  </td>
                  <td class="text-center text-break">
                    <i class="fa fa-door-closed"></i> {{ plant.RoomName }}
                  </td>
                  <td class="text-center">
                    <button class="btn btn-info" title="Change Growth Phase" @click.prevent="showChangeGrowthPhaseModal(plant)">
                      <i class="fa fa fa-exchange-alt text-white"></i>
                    </button>
                    <button class="btn btn-info" title="Move Plant" @click.prevent="showMovePlantModal(plant)">
                      <i class="fa fa-angle-double-right text-white"></i>
                    </button>
                    <button class="btn btn-info" title="Manicure Plant" @click.prevent='showManicurePlantModal(plant.Label)'>
                      <i class="fa fa-volume-up fa-rotate-90 text-white"></i>
                    </button>
                    <button class="btn btn-info" title="Harvest Plant" @click.prevent="showHarvestPlantModal(plant.Label)">
                      <i class="fa fa-cut text-white"></i>
                    </button>
                    <button class="btn btn-danger" title="Destroy" @click.prevent='showDestroyPlant(plant)'>
                      <i class="fa fa-times text-white"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    
    <!--Begin change-plant-growth-phase modal-window -->
    <ChangePlantGrowthPhase ref="changeGrowthPhase"></ChangePlantGrowthPhase>
    <!--End change-plant-growth-phase modal-window -->
    
    <!--Begin move-plants modal-window -->
    <MovePlant ref="movePlant" @loadPlants="fetch"></MovePlant>
    <!--End move-plants modal-window -->
    
    <!--Begin harvest-plant/manicure-plant modal-window-->
    <HarvestPlant ref="harvestPlant"></HarvestPlant>
    <!--Begin harvest-plant/manicure-plant modal-window-->
    
    <!--Begin destroy-plant modal-window-->
    <DestroyPlant ref='destroyPlant' @loadPlants="fetch"></DestroyPlant>
    <!--End destroy-plant modal-window-->
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
import Navigation from '@/components/Navigation';
import AlertMessageModal from '@/components/AlertMessageModal';
import ChangePlantGrowthPhase from '@/components/modals/ChangePlantGrowthPhase';
import MovePlant from '@/components/modals/MovePlant';
import HarvestPlant from '@/components/modals/HarvestPlant';
import DestroyPlant from '@/components/modals/DestroyPlant';
import { helper } from '@/helper.js';
import $ from 'jquery';
import * as select2 from 'select2/dist/js/select2.full.js';
import 'select2/dist/css/select2.min.css';

Vue.use(VueSpinners);
export default {
  name: 'VegetativeOverview',
  data() {
    return {
      vegetativePlants: [],
      isTableEnabled: false,
      showLoader: false
    };
  },
  components: {
    Navigation,
    AlertMessageModal,
    HashLoader,
    ChangePlantGrowthPhase,
    MovePlant,
    HarvestPlant,
    DestroyPlant
  },
  created() {
    this.fetch(false);
    this.removeFile('/static/js/oneui.app.min.js', 'js');
    this.removeFile('/static/js/be_tables_datatables.min.js', 'js');
    this.loadFile('/static/js/oneui.app.min.js', 'js');  
    this.loadFile('/static/js/be_tables_datatables.min.js', 'js');    
  },
  computed: {
    ...mapState({
      library: state => state.library
    }),
    getVegetativePlantEntries() {
      if (this.$store.state.library.vegetativePlants.length) {
        return this.enableDataTable(this.$store.state.library.vegetativePlants);
      }
    }
  },
  mounted() {
    $('.v-plant-select2-dropdown').each(function(){
      $(this).select2({
        dropdownParent: $(this).parent(),
        placeholder: $(this).attr('placeholder')
      });
    });
  },
  methods: {
    ...mapActions('library', ['getAllVegetativePlants']),
    ...mapGetters('library', ['getVegetativePlants']),
    async fetch(force) {
      if (force || this.getVegetativePlants().length === 0) {
        this.showLoader = true;
        await this.getAllVegetativePlants();
      }
      if (this.getVegetativePlants().length === 0) {
        this.enableDataTable([]);
      }
    },
    enableDataTable(data) {
      let vm = this, table;
      vm.showLoader = true;
      if (vm.isTableEnabled) {
        table = jQuery('#vegetative-overview-table').DataTable();
        table.destroy();
      }
      vm.vegetativePlants = data;
      helper.prepareDataTable('#vegetative-overview-table', 5);
      vm.isTableEnabled = true;
      vm.showLoader = false;
    },
    showChangeGrowthPhaseModal(plant) {
      this.$refs.changeGrowthPhase.setPlantDetails(plant, 'bg-info');
      jQuery('#change-plant-growth-phase').modal('show');
    },
    showMovePlantModal(plant) {
      this.$refs.movePlant.setPlantDetails(plant, 'bg-info');
      jQuery('#move-plant').modal('show');
    },
    showHarvestPlantModal(plantLabel) {
      this.$refs.harvestPlant.setPlantLabel(plantLabel, 'bg-info', 'harvestplants');
      jQuery('#harvest-plant').modal('show');
    },
    showManicurePlantModal(plantLabel) {
      this.$refs.harvestPlant.setPlantLabel(plantLabel, 'bg-info', 'manicureplants');
      jQuery('#harvest-plant').modal('show');
    },
    showDestroyPlant(plant) {
      this.$refs.destroyPlant.setPlantDetails(plant, 'bg-info');
      jQuery('#destroy-plant').modal('show');
    }
  }
};
</script>



// WEBPACK FOOTER //
// source/components/VegetativeOverview.vue